import Vue from "vue";
import {
  formatNum,
  formatPhone,
  link,
  toZhDate,
  format,
  toW
} from "@/utils/index";

/**
 * 格式化数字等，以千分号隔开
 **/
Vue.filter("toThousands", formatNum);
Vue.filter("toZhDate", toZhDate);
Vue.filter("formatPhone", formatPhone);
Vue.filter("formatPhone2", str => formatPhone(str, 2));
Vue.filter("formatPhone3", str => formatPhone(str, 3));

Vue.filter("link", (arr, separator) => link(arr, separator));

Vue.filter("formatGender", str => {
  /*
   *先生OR女士
   */
  let gender = str;
  switch (Number(str)) {
    case 1:
      gender = "先生";
      break;
    case 2:
      gender = "女士";
      break;
    default:
      gender = "";
  }
  return gender;
});

Vue.filter("converDate", obj => {
  /**
   *计算时间
   *@String | Number : obj 时间戳或者标准时间格式字符串
   **/
  if (!obj) {
    return;
  }
  const conver = num => {
    //补0
    return num < 10 ? `0${num}` : num;
  };
  let str = typeof obj == "string" ? obj.replace(/-/g, "/") : obj;
  const bDate = new Date(str); //需要判断的时间
  console.log(bDate);
  const aDate = new Date(); //当前时间
  const bYear = bDate.getFullYear();
  const bMonth = bDate.getMonth() + 1;
  const bDay = bDate.getDate();
  const bHour = conver(bDate.getHours());
  const bMin = conver(bDate.getMinutes());
  const aYear = aDate.getFullYear();
  const aMonth = aDate.getMonth() + 1;
  const aDay = aDate.getDate();

  if (bYear == aYear && bMonth == aMonth && bDay == aDay) {
    //今天
    return `${bHour}:${bMin}`;
  }
  if (bYear == aYear) {
    //今年
    return `${conver(bMonth)}月${conver(bDay)}日`;
  }
  //其他年
  return `${bYear}年${conver(bMonth)}月${conver(bDay)}日`;
});

Vue.filter("isEmpty", obj => {
  /*
   *为空时返回 ‘暂无数据’
   */
  if ((typeof obj == "object" && !obj) || obj === "") {
    //判断对象是null 或者 ''空串
    return "暂无数据";
  }
  return obj;
});

Vue.filter("isEmpty2", obj => {
  /*
   *为空时返回 ‘暂无数据’
   */
  if ((typeof obj == "object" && !obj) || obj === "") {
    //判断对象是null 或者 ''空串
    return "-";
  }
  return obj;
});

Vue.filter("toFix2", num => {
  /*
   *保留两位小数
   */
  if (typeof num == "number") {
    return num.toFixed(2);
  }
  if (typeof num == "string") {
    if (!isNaN(Number(num))) {
      return Number(num).toFixed(2);
    }
  }
  return num;
});

Vue.filter("toIntCeil", num => {
  /*
   *向上取整 保留整数
   */
  if (!num) return num;
  if (typeof num == "number") {
    return Math.ceil(num);
  }
  if (typeof num == "string") {
    if (!isNaN(Number(num))) {
      return Math.ceil(num);
    }
  }
  return num;
});

Vue.filter("toInt", num => {
  /*
   *保留整数
   */
  if (typeof num == "number") {
    return parseInt(num);
  }
  if (typeof num == "string") {
    if (!isNaN(Number(num))) {
      return parseInt(num);
    }
  }
  return num;
});

Vue.filter("toBankNum", str => {
  /*
   *格式化银行卡号
   */
  let bankNum = str.replace(/(\d{4})(?=\d)/g, "$1 ");
  return bankNum;
});

Vue.filter("toCircleNum", num => {
  /*
   *把数字变成圈数字
   */
  let index = 9311 + num;
  let circleNum = String.fromCharCode(index);
  return circleNum;
});

Vue.filter("formatDate", (str, type = 2) => {
  return format.date(str, type);
});

Vue.filter("toW", toW);
